import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import Image from "next/legacy/image";
import { PartnershipsImageCarousel } from "../components";
import { storyblokComponents } from "../data/storyblok-renderer-map";
import styles from "./partnerships.module.css";
export function PartnershipsFeature({ story , preview , generatedAt  }) {
    var ref, ref1;
    const typedStory = story;
    const { content  } = useStoryblokState({
        story: typedStory,
        enableBridge: preview
    });
    const image = content.Image;
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Partnerships - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ _jsxs("article", {
                children: [
                    /*#__PURE__*/ _jsxs(Wrapper, {
                        isSlim: true,
                        children: [
                            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                                block: content.Intro,
                                components: storyblokComponents
                            }),
                            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                                block: content.Partners,
                                components: storyblokComponents
                            })
                        ]
                    }),
                    (content === null || content === void 0 ? void 0 : (ref1 = content.ImageCarousel) === null || ref1 === void 0 ? void 0 : ref1.some((image)=>image.filename)) ? /*#__PURE__*/ _jsx(Wrapper, {
                        isFluid: true,
                        children: /*#__PURE__*/ _jsx(PartnershipsImageCarousel, {
                            images: content === null || content === void 0 ? void 0 : content.ImageCarousel
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ _jsx("div", {
                            className: styles.imageWrapper,
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                layout: "intrinsic",
                                width: "801",
                                height: "481",
                                objectFit: "contain"
                            })
                        }) : null
                    })
                ]
            })
        ]
    });
}
export default PartnershipsFeature;
